import {
  Box,
  Button,
  Container,
  FormField,
  Grid,
  Input,
  SpaceBetween,
  Textarea,
} from '@amzn/awsui-components-core';
import { Epic } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { v4 as uuid } from 'uuid';
import constants from '../../../common/constants';
import EditorWrapper from '../../../editor/EditorWrapper';
import { TiptapOutputType } from '@amzn/awscat-editor';
import { getText } from '@amzn/awscat-editor';
import { TiptapMenuType } from '../../../editor/utils';

interface Props {
  epics: Epic[];
  confirmAddEpic: (epic: Epic) => void;
}

interface State {
  title: TiptapOutputType;
  description: TiptapOutputType;
  titleError: string;
  visible: boolean;
}

class EpicCreatorForm extends React.Component<Props, State> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.state = {
      description: '',
      title: '',
      titleError: '',
      visible: true,
    };
  }

  public render() {
    const rows = 3;
    const { title, description, visible } = this.state;
    const epicDescEditor = (
      <EditorWrapper
        model={description}
        readOnly={false}
        onModelChange={this.updateEpicDescription}
        menuType={TiptapMenuType.OnlyLink}
      />
    );

    const epicTitleEditor = (
      <EditorWrapper
        model={title}
        readOnly={false}
        onModelChange={this.updateEpicTitle}
        menuType={TiptapMenuType.OnlyLink}
      />
    );
    return visible ? (
      <Box margin={{ top: 'l' }}>
        <Container className="epic-creator-container">
          <SpaceBetween direction={'vertical'} size={'s'}>
            <Grid gridDefinition={[{ colspan: { default: 12 } }]}>
              <FormField
                className="epic-creator-title"
                label={constants.EPIC_TITLE_LABEL}
                errorText={this.state.titleError}
                stretch
                i18nStrings={{ errorIconAriaLabel: 'Error' }}
              >
                <Box variant="div" padding={{ top: 's' }}>
                  <div className="editorbox-small">{epicTitleEditor}</div>
                </Box>
              </FormField>
            </Grid>
            <Grid gridDefinition={[{ colspan: { default: 12 } }]}>
              <FormField
                label={<span>{constants.EPIC_DESCRIPTION_LABEL} (optional)</span>}
                stretch
                i18nStrings={{ errorIconAriaLabel: 'Error' }}
              >
                <Box variant="div" padding={{ top: 's' }}>
                  <div className="editorbox-small">{epicDescEditor}</div>
                </Box>
              </FormField>
            </Grid>
            <Box margin={{ top: 's' }} float={'right'}>
              <Button variant={'link'} onClick={this.cancelEpic}>
                {constants.CANCEL_BUTTON_TEXT}
              </Button>
              <Button onClick={this.confirmAddEpic}>{constants.CONFIRM_BUTTON_TEXT}</Button>
            </Box>
          </SpaceBetween>
        </Container>
      </Box>
    ) : null;
  }

  public componentDidUpdate = (prevProps: any, prevState: any) => {
    if (this.state.title !== prevState.title) {
      this.validateInput();
    }
  };

  private updateEpicDescription = (content: TiptapOutputType) => {
    this.setState({ description: content });
  };

  private updateEpicTitle = (content: TiptapOutputType) => {
    this.setState({ title: content });
  };

  private confirmAddEpic = () => {
    const { title, description } = this.state;
    const { confirmAddEpic } = this.props;
    const error = this.validateInput();

    if (!error && confirmAddEpic) {
      confirmAddEpic(
        Object.assign(new Epic(), {
          description,
          id: uuid(),
          tasks: [],
          title,
        }),
      );
      this.setState({
        visible: false,
      });
    }
  };

  private cancelEpic = () => {
    this.setState({
      visible: false,
    });
  };

  private validateInput = () => {
    let error: string;
    const { title } = this.state;

    if (!title || getText(title).length <= 0) {
      error = constants.EPIC_TITLE_REQUIRED;
    } else if (getText(title).length > 300) {
      error = constants.EPIC_TITLE_TOO_LONG;
    } else if (this.checkDuplicateTitle.call(this, title)) {
      error = constants.DUPLICATE_EPIC_TITLE;
    }

    this.setState({
      // @ts-expect-error TS2454 - strict migration
      titleError: error,
    });

    // @ts-expect-error TS2454 - strict migration
    return error;
  };

  private checkDuplicateTitle = (title: TiptapOutputType) => {
    const { epics } = this.props;
    return (
      Array.isArray(epics) &&
      epics.length > 0 &&
      epics.findIndex((epic) => getText(epic.title) === getText(title)) !== -1
    );
  };
}

export default EpicCreatorForm;
